/**
 * AGRO-INVEST Admin API Service
 * All admin dashboard API calls
 */

import { api } from './api';

export const adminApi = {
  // Dashboard
  getDashboard() {
    return api.get('/api/admin/dashboard');
  },

  // Farmers
  getFarmers(params = {}) {
    const q = Object.entries(params).filter(([, v]) => v != null && v !== '').reduce((o, [k, v]) => ({ ...o, [k]: v }), {});
    const search = new URLSearchParams(q).toString();
    return api.get(`/api/admin/farmers${search ? `?${search}` : ''}`);
  },
  getFarmer(id) {
    return api.get(`/api/admin/farmers/${id}`);
  },
  updateFarmerStatus(id, status) {
    return api.patch(`/api/admin/farmers/${id}/status`, { status });
  },
  deleteFarmer(id) {
    return api.delete(`/api/admin/farmers/${id}`);
  },

  // Suppliers
  getSuppliers(params = {}) {
    const q = Object.entries(params).filter(([, v]) => v != null && v !== '').reduce((o, [k, v]) => ({ ...o, [k]: v }), {});
    const search = new URLSearchParams(q).toString();
    return api.get(`/api/admin/suppliers${search ? `?${search}` : ''}`);
  },
  getSupplier(id) {
    return api.get(`/api/admin/suppliers/${id}`);
  },
  updateSupplierStatus(id, status) {
    return api.patch(`/api/admin/suppliers/${id}/status`, { status });
  },
  deleteSupplier(id) {
    return api.delete(`/api/admin/suppliers/${id}`);
  },

  // Risk Scores
  getRiskScores(params = {}) {
    const q = Object.entries(params).filter(([, v]) => v != null && v !== '').reduce((o, [k, v]) => ({ ...o, [k]: v }), {});
    const search = new URLSearchParams(q).toString();
    return api.get(`/api/admin/risk-scores${search ? `?${search}` : ''}`);
  },
  getRiskScore(farmerId) {
    return api.get(`/api/admin/risk-scores/${farmerId}`);
  },

  // Vouchers
  getVouchers(params = {}) {
    const q = Object.entries(params).filter(([, v]) => v != null && v !== '').reduce((o, [k, v]) => ({ ...o, [k]: v }), {});
    const search = new URLSearchParams(q).toString();
    return api.get(`/api/admin/vouchers${search ? `?${search}` : ''}`);
  },
  createVoucher(data) {
    return api.post('/api/admin/vouchers', data);
  },
  getVoucher(id) {
    return api.get(`/api/admin/vouchers/${id}`);
  },

  // Financing
  getFinancing(params = {}) {
    const q = Object.entries(params).filter(([, v]) => v != null && v !== '').reduce((o, [k, v]) => ({ ...o, [k]: v }), {});
    const search = new URLSearchParams(q).toString();
    return api.get(`/api/admin/financing${search ? `?${search}` : ''}`);
  },
  updateFinancingStatus(id, status) {
    return api.patch(`/api/admin/financing/${id}/status`, { status });
  },
  createFinancing(data) {
    return api.post('/api/admin/financing', data);
  },

  // Investors
  getInvestors(params = {}) {
    const q = Object.entries(params).filter(([, v]) => v != null && v !== '').reduce((o, [k, v]) => ({ ...o, [k]: v }), {});
    const search = new URLSearchParams(q).toString();
    return api.get(`/api/admin/investors${search ? `?${search}` : ''}`);
  },
  updateInvestorStatus(id, status) {
    return api.patch(`/api/admin/investors/${id}/status`, { status });
  },
  deleteInvestor(id) {
    return api.delete(`/api/admin/investors/${id}`);
  },
};
